import { render, staticRenderFns } from "./NodeContent.vue?vue&type=template&id=645aa214&scoped=true&"
import script from "./NodeContent.vue?vue&type=script&lang=js&"
export * from "./NodeContent.vue?vue&type=script&lang=js&"
import style0 from "./NodeContent.vue?vue&type=style&index=0&id=645aa214&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645aa214",
  null
  
)

export default component.exports